module.exports = __webpack_public_path__ + "static/media/premium-purchase-setup.99822f9e.svg";